import React from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'

import { ContentSobreNosotros } from '../../components/sobreNosotros/ContentSobreNosotros'
import HeaderHome from '../../components/headerHome/HeaderHome'
import { Helmet } from 'react-helmet'

export const SobreNosotros = () => {

    return (
        <div>
            <Helmet>
                <link rel="canonical" href="https://www.cuidatia.org/sobre-nosotros" />
            </Helmet>
            <div className='headerPagina' >
                <HeaderHome />
            </div>
            <div>
                <ContentSobreNosotros />
            </div>
            <div className='footerReservarServicio'>
                <MiFooter />
            </div>
        </div>
    )
}